import styles from './FreeTierUpsellModalNewPlans.module.scss';
import { useNavigate } from 'react-router-dom';
import { useGetUser, useSubscriptionInfo } from 'src/hooks';
import { useChoosePlanModal } from 'src/hooks/useChoosePlanModal';
import { toast } from 'react-toastify';
import {
  APPLE_PAYMENT_UPGRADE_ERROR_TEXT,
  FREE_TIER_WELCOME_MODAL_NEW_PLANS,
  SUBSCRIPTION_PENDING_CHANGES_NOTIFICATION_MESSAGE,
  SUPER_PROJECT_NAME,
  SVG_SIZE_M,
} from 'src/constants';
import { AppRoutes } from 'src/types';
import { Modal } from 'src/components/Modal';
import { Button } from 'src/v2/commonComponents/Button';
import { X } from '@phosphor-icons/react';
import { PlanCard } from './components/PlanCard';
import { env } from 'src/env';
import { StudentDiscountMessageBlock } from 'src/v2/components/StudentDiscountMessageBlock';
import { useFeatureFlagEnabled } from 'posthog-js/react';

// TODO: move it as a variantB to the FreeTierUpsellModal
export const FreeTierUpsellModalNewPlans = () => {
  const navigate = useNavigate();
  const { isFreeTier, isEducationUser } = useGetUser();
  const {
    shouldShowPlanModal,
    changeChoosePlanModalState,
    neverShowPlanModalAgain,
  } = useChoosePlanModal();
  const { subscriptionInfo, isAppleOrAmpPayment } = useSubscriptionInfo();
  const disableRequestsInMNForFreeTier = useFeatureFlagEnabled(
    'disableRequestsInMNForFreeTier',
  );

  const handleCloseClick = () => {
    changeChoosePlanModalState({
      shouldShow: false,
      lastTimeWasShown: new Date(),
    });
  };

  const handleUpdateClick = () => {
    if (
      !!subscriptionInfo?.is_cancelled ||
      !!subscriptionInfo?.has_scheduled_downgrade ||
      !!subscriptionInfo?.has_scheduled_plan_change ||
      !!subscriptionInfo?.processing_plan_change ||
      isAppleOrAmpPayment
    ) {
      toast.error(
        isAppleOrAmpPayment
          ? APPLE_PAYMENT_UPGRADE_ERROR_TEXT
          : SUBSCRIPTION_PENDING_CHANGES_NOTIFICATION_MESSAGE,
      );
      handleCloseClick();
    } else {
      handleCloseClick();
      navigate(AppRoutes.PAYMENT);
    }
  };

  const handleGoToSNClick = () => {
    handleCloseClick();
    window.location.href = env.REACT_APP_SUPER_NINJA_URL;
  };

  return (
    <div className={styles.root}>
      <Modal
        open={
          shouldShowPlanModal &&
          isFreeTier &&
          !neverShowPlanModalAgain &&
          !disableRequestsInMNForFreeTier
        }
        onClose={handleCloseClick}
        className={styles.modal}
        overlayClassName={styles.overlay}
        showCloseIcon={false}
        blockScroll={false}
      >
        <div className={styles.content} data-e2e="basic-tier-welcome-modal">
          <Button
            color="transparent"
            className={styles.closeButton}
            onClick={handleCloseClick}
            data-e2e="update-modal-close-button"
          >
            <X size={SVG_SIZE_M} />
          </Button>

          <div className={styles.titleWrapper}>
            <h2 className={styles.title}>Welcome to Ninja!</h2>

            <h4 className={styles.description}>
              Enjoy free {SUPER_PROJECT_NAME} tasks to experience the future of
              work!
            </h4>

            {isEducationUser && <StudentDiscountMessageBlock />}

            <h3 className={styles.subtitle}>
              Get unlimited tasks & premium access
            </h3>
          </div>

          <div className={styles.plans}>
            {Object.values(FREE_TIER_WELCOME_MODAL_NEW_PLANS).map(
              ({
                title,
                description,
                icon,
                features,
                minPrice,
                maxPrice,
                isSuperNinja,
              }) => (
                <PlanCard
                  key={title}
                  title={title}
                  icon={icon}
                  description={description}
                  features={features}
                  // minPrice={minPrice} // temporarily removed
                  maxPrice={maxPrice}
                  isSuperNinja={isSuperNinja}
                />
              ),
            )}
          </div>

          <div className={styles.footer}>
            <Button color="highlight" onClick={handleUpdateClick}>
              Upgrade
            </Button>
            <Button
              className={styles.goToSNButton}
              color="link"
              onClick={handleGoToSNClick}
            >
              Upgrade later, start first task
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
